import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fa-caretup",
  "use": "fa-caretup-usage",
  "viewBox": "0 0 320 512",
  "content": "<symbol stroke=\"currentColor\" fill=\"currentColor\" stroke-width=\"0\" viewBox=\"0 0 320 512\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fa-caretup\"><path d=\"M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z\" stroke=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol